import { createSelector } from "@ngrx/store";
import * as fromMain from '@features/mes-remboursements/store/main.reducer';

const selectMesRemboursementsState = fromMain.mesRemboursementsFeature.selectMesPaiementsPageState;

export const selectMesRemboursements = createSelector(selectMesRemboursementsState, (state) => state.mesRemboursements.entities);
export const selectMesRemboursementsLoading = createSelector(selectMesRemboursementsState, (state) => state.mesRemboursements.loading);
export const selectMesRemboursementsExportLoading = createSelector(selectMesRemboursementsState, (state) => state.mesRemboursements.exportLoading);
export const selectMesRemboursementsTotalElements = createSelector(selectMesRemboursementsState, (state) => state.mesRemboursements.totalElements);
